var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "journey-builder-composer-zoom",
    {
      attrs: { proxy: true },
      on: {
        "proxy-zoom-with-wheel": function($event) {
          ;(_vm.$refs.actualZoom
            ? _vm.$refs.actualZoom.zoomWithWheel
            : function() {}
          ).apply(void 0, arguments)
        },
        "proxy-add-pan": function($event) {
          ;(_vm.$refs.actualZoom
            ? _vm.$refs.actualZoom.addPan
            : function() {}
          ).apply(void 0, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "composer-root" },
        [
          _c("drag-and-drop-wrapper", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var jsPlumbInstance = ref.jsPlumbInstance
                  return [
                    _c(
                      "journey-builder-composer-zoom",
                      {
                        ref: "actualZoom",
                        on: {
                          "scale-changed": function($event) {
                            return _vm.zoomChanged(jsPlumbInstance, $event)
                          },
                          "pan-changed": _vm.panChanged
                        }
                      },
                      [
                        _c("journey-builder-composer-connection-manager", {
                          attrs: { "js-plumb-instance": jsPlumbInstance },
                          on: {
                            "connection-created": function($event) {
                              return _vm.$emit("connection-created", $event)
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var connectNewCircleBricks =
                                    ref.connectNewCircleBricks
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "compose-area" },
                                      [
                                        _vm._l(_vm.journeyBricks, function(
                                          brick
                                        ) {
                                          return [
                                            _c(
                                              "drag-and-drop-draggable",
                                              {
                                                key: brick.id,
                                                attrs: {
                                                  "js-plumb-instance": jsPlumbInstance
                                                },
                                                on: {
                                                  start: function($event) {
                                                    return _vm.brickMoveStarted(
                                                      brick.id
                                                    )
                                                  },
                                                  stop: _vm.brickMoveStopped
                                                }
                                              },
                                              [
                                                _c(
                                                  "journey-brick-square-endpoints",
                                                  {
                                                    attrs: {
                                                      "js-plumb-instance": jsPlumbInstance,
                                                      "brick-id": brick.id,
                                                      "incoming-connections":
                                                        brick.incomingConnections,
                                                      "outgoing-connections":
                                                        brick.outgoingConnections,
                                                      "accepts-incoming-connections": !brick.isChildJourneyBrick
                                                    }
                                                  },
                                                  [
                                                    _c(brick.brickComponent, {
                                                      ref: brick.id,
                                                      refInFor: true,
                                                      tag: "component",
                                                      staticClass:
                                                        "composer-component",
                                                      attrs: {
                                                        isActive:
                                                          brick.isActive,
                                                        id: brick.id,
                                                        name: brick.name,
                                                        type: brick.type,
                                                        config: brick.config,
                                                        availableConditions:
                                                          _vm.availableConditions,
                                                        "is-child-journey-brick":
                                                          brick.isChildJourneyBrick,
                                                        "incoming-connections-info":
                                                          brick.incomingBrickConnections,
                                                        "outgoing-connections-info":
                                                          brick.outgoingBrickConnections,
                                                        x: brick.x,
                                                        y: brick.y,
                                                        "is-new": brick.isNew
                                                      },
                                                      on: {
                                                        "add-connection": function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "add-connection",
                                                            brick
                                                          )
                                                        },
                                                        "delete-brick": function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "delete",
                                                            {
                                                              brick: brick,
                                                              requiresPrompt: $event
                                                            }
                                                          )
                                                        },
                                                        "settings-changed": function(
                                                          $event
                                                        ) {
                                                          _vm.$emit(
                                                            "settings-changed",
                                                            Object.assign(
                                                              { id: brick.id },
                                                              $event
                                                            )
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.brickConnectors, function(
                                          ref
                                        ) {
                                          var connector = ref.connector
                                          var connection = ref.connection
                                          var isActive = ref.isActive
                                          var isDeduplicationActive =
                                            ref.isDeduplicationActive
                                          return _c(
                                            "drag-and-drop-draggable",
                                            {
                                              key: connection.id,
                                              attrs: {
                                                "js-plumb-instance": jsPlumbInstance
                                              },
                                              on: {
                                                start: function($event) {
                                                  return _vm.brickMoveStarted(
                                                    connection.id
                                                  )
                                                },
                                                stop: function($event) {
                                                  return _vm.connectorMoved(
                                                    connection.id,
                                                    connection.sourceBrickId,
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "journey-brick-circle-endpoints",
                                                {
                                                  attrs: {
                                                    "js-plumb-instance": jsPlumbInstance,
                                                    "connection-id":
                                                      connection.id,
                                                    "source-brick-id":
                                                      connection.sourceBrickId,
                                                    "destination-brick-id":
                                                      connection.destinationBrickId,
                                                    "is-active": isActive
                                                  },
                                                  on: {
                                                    "endpoints-updated": function(
                                                      $event
                                                    ) {
                                                      return connectNewCircleBricks(
                                                        $event.created,
                                                        connection
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("journey-brick-circle", {
                                                    ref: connection.id,
                                                    refInFor: true,
                                                    staticClass:
                                                      "composer-component",
                                                    attrs: {
                                                      "is-active": isActive,
                                                      "is-deduplication-active": isDeduplicationActive,
                                                      type: connector.type,
                                                      config: connector.config,
                                                      x: connector.connectorX,
                                                      y: connector.connectorY,
                                                      connection: connection
                                                    },
                                                    on: {
                                                      "change-connection": function(
                                                        $event
                                                      ) {
                                                        return _vm.changeConnection(
                                                          connection.sourceBrickId,
                                                          $event
                                                        )
                                                      },
                                                      "delete-connection": function(
                                                        $event
                                                      ) {
                                                        return _vm.deleteConnection(
                                                          connection.sourceBrickId,
                                                          connection.destinationBrickId,
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }